import { render } from "./editPageModal.vue?vue&type=template&id=12362a08"
import script from "./editPageModal.vue?vue&type=script&lang=js"
export * from "./editPageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__